
import Stream from 'frp/stream'

export function fieldName( obj, field )
{
    for ( const name in obj )
    {
        if ( obj[ name ] === field ) return name;
    }
}

export function Image( name )
{
    const texture = PIXI.utils.TextureCache[ name ]
    if ( ! texture ) {
        let msg = ''
        for ( let i in PIXI.utils.TextureCache ) msg = msg + i + ','
        throw "no texture " + name + '. Available textures: ' + msg
    }
    return new PIXI.Sprite( texture )
}

export function load_source( url )
{
    const scr  = document.createElement( 'script' )
    const head = document.head || document.getElementsByTagName('head')[0]
    scr.src = url
    scr.async = false; // optionally

    head.insertBefore( scr, head.firstChild )
}

export function UrlParamsToObject()
{
    const result = {};
    const pairs = window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' );

    for ( let i = 0; i < pairs.length; ++i )
    {
        const pair = pairs[ i ].split( '=' );
        let value = pair[ 1 ];
        if ( value === undefined )
        {
            value = true;
        }
        result[ pair[ 0 ] ] = value;
    }
    return result;
}

/** Keep sound playing while previous stream value is true */
Stream.prototype.sound = function({ name, loop = true })
{
    const s = sounds.get( name )
    s.loop( loop )

    return this.on( play => {
        if ( play && ! s.playing() ) s.play()
        if ( ! play && s.playing() ) s.stop()
    })
}
export function kill_sound( s )
{
    try
    {
        //remove all listeners first so that onstop() won't be called as well:
        s.off()
        s.stop()
    }
    catch(e){}
}

/** Get specified deep property from object with fallback to specified value if it cannot be retrieved.
@param object object to obtain property from
@param prop deeply sequenced array of properties to obtain
@param fallback value to return in case specified deep property cannot be retrieved
@param desc literal prefix for console error message when property cannot be retrieved. No message will be printed if not specified.*/
export function get_prop( object, prop, fallback, desc )
{
    for ( let i = 0; i < prop.length; ++ i )
    {
        const prop_name = prop[ i ]
        object = object === undefined ? undefined : object[ prop_name ]
        
        if ( object === undefined )
        {
            if ( desc ) console.error( desc, 'no', prop_name, 'property' )
            return fallback
        }
    }
    return object
}

export function in_iframe()
{
    try {
        return window.self !== window.top
    } catch (e) {
        return true
    }
}

/** Inclusively */
export function random_int( min, max )
{
    return Math.floor(Math.random() * (max - min + 1)) + min
}

export function canFullscreen() {
    return !!(
        window.document.documentElement.requestFullscreen ||
        window.document.documentElement.mozRequestFullScreen ||
        window.document.documentElement.webkitRequestFullScreen
    )
}

export function canScreenLock() {
    return !!(window.screen.orientation && window.screen.orientation.lock)
}

export function is_fullscreen() {
    const doc = window.document;

    return !!(doc.fullscreenElement || doc.mozFullScreenElement || doc.webkitFullscreenElement)
}

export function positioner( space, target, name )
{
    target.positioner_disp = { x : 0, y : 0 }
    space.s( 'keyboard' ).on( k => {
        switch ( k )
        {
            //left:
            case 37:
                target.positioner_disp.x -= 1
                target.position.x -= 1
                break
            
            //up:
            case 38:
                target.positioner_disp.y -= 1
                target.position.y -= 1
                break
            
            //right:
            case 39:
                target.positioner_disp.x += 1
                target.position.x += 1
                break
            
            //down:
            case 40:
                target.positioner_disp.y += 1
                target.position.y += 1
                break
        }

        if ( name ) console.log( name, ':', target.positioner_disp.x, target.positioner_disp.y )
    })
}

/** Position on Bezier Curve
 * points: [ [ 100, 100 ], [ 200, 200 ], ... ]
 * karet: value from 0 to 1 (values <0 and >1 are undefined (pretty sophisticated curve prolongations))
*/
export function bezier( points, karet )
{
    //resulting point calculation is done by connecting point on first line (line from point 1 to point 2) with point on second line (2-3). It effectively decreases amount of lines (points) by one every time. Then repeat until there will remain no lines
	
    //intermediate array which will be used to modify points:
    let copy = points.map( a => a.slice() )
	
	for ( let i = points.length; i >= 2; -- i )
	{
		for ( let i2 = 0; i2 < ( i - 1 ); ++ i2 )
		{
            const p1 = copy[ i2 ]
            const p2 = copy[ i2 + 1 ]
            for ( const j in p1 ) p1[ j ] = p1[ j ] + ( p2[ j ] - p1[ j ] ) * karet
		}
    }
    
    return copy[ 0 ]
}



// WEBPACK FOOTER //
// ./src/library/utils.es6